import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowLeft, FileText } from "lucide-react";
import { useTranslation } from "react-i18next";

const ChangelogHeader = () => {
  const { t } = useTranslation('changelog');

  return (
    <div className="mb-8">
      <Link to="/" className="text-uplivion-blue hover:underline mb-4 inline-block">
        {t('header.backToHome')}
      </Link>
      <div className="flex items-center gap-3 mb-4">
        <FileText className="w-8 h-8 text-uplivion-blue" />
        <h1 className="text-3xl font-bold text-foreground">{t('header.title')}</h1>
      </div>
      <p className="text-xl text-muted-foreground mb-6">
        {t('header.subtitle')}
      </p>
      <div className="bg-blue-50 border-l-4 border-uplivion-blue p-4 rounded-r-lg">
        <p className="text-sm text-uplivion-blue">
          {t('header.description')}
        </p>
      </div>
    </div>
  );
};

export default ChangelogHeader;